import { defineComponent as o, openBlock as n, createBlock as i, withCtx as m, createVNode as e, unref as t } from "vue";
import { RevSkeleton as r } from "@ds/components/Skeleton";
import a from "./DocumentLabelWrapper.vue2.js";
const h = /* @__PURE__ */ o({
  name: "DocumentLoading",
  __name: "DocumentLoading",
  setup(c) {
    return (s, f) => (n(), i(a, { class: "border-static-default-mid flex min-h-40 w-full items-center justify-between border px-12 py-22" }, {
      default: m(() => [
        e(t(r), {
          height: "1.25rem",
          shape: "circle",
          width: "1.25rem"
        }),
        e(t(r), {
          class: "grow",
          height: "1.25rem",
          shape: "line",
          width: "100%"
        })
      ]),
      _: 1
    }));
  }
});
export {
  h as default
};
